const STORAGE_KEY = "nm_faq_content";

const DEFAULT_ANSWER = "Обеспечивается за счет качества исходного сырья. Для изготовления пружин мы выбираем лучшие материалы: стальную углеродистую проволоку (ГОСТу 9389), прочное износостойкое нетканое полотно «Спанбонд» и термоплавкий клей. Материалы предварительно проверяются на соответствие стандартам.";

const DEFAULT_LIST_ITEMS = [
  "Платформа — программно-аппаратные средства, интегрированные с cайтом Администрации.",
  "Пользователь — дееспособное физическое лицо, присоединившееся к настоящему соглашению в собственном интересе либо выступающее от имени и в интересах представляемого им юридического лица.",
  "Сайт — интернет-сайты, размещенные в домене www и его поддоменах.",
];

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function createId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function getDefaultItems() {
  return [
    {
      id: "faq-1",
      question: "Возможно ли предоставление рассрочки?",
      answer: DEFAULT_ANSWER,
      listTitle: "",
      listType: "ul",
      listItems: [...DEFAULT_LIST_ITEMS],
      showOnHome: true,
    },
    {
      id: "faq-2",
      question: "Работаем ли с юрлицами? А с физлицами?",
      answer: DEFAULT_ANSWER,
      listTitle: "",
      listType: "ul",
      listItems: [...DEFAULT_LIST_ITEMS],
      showOnHome: true,
    },
    {
      id: "faq-3",
      question: "Какие схемы оплаты за услуги существуют в агентстве?",
      answer: DEFAULT_ANSWER,
      listTitle: "",
      listType: "ul",
      listItems: [...DEFAULT_LIST_ITEMS],
      showOnHome: true,
    },
    {
      id: "faq-4",
      question: "Какие надбавки за срочные заказы или монтажные работы в дневное/ночное время/праздничные дни и выходные?",
      answer: DEFAULT_ANSWER,
      listTitle: "Заголовок списка:",
      listType: "ol",
      listItems: [...DEFAULT_LIST_ITEMS],
      showOnHome: true,
    },
    {
      id: "faq-5",
      question: "Какие сроки выполнения заказа?",
      answer: DEFAULT_ANSWER,
      listTitle: "",
      listType: "ul",
      listItems: [...DEFAULT_LIST_ITEMS],
      showOnHome: true,
    },
    {
      id: "faq-6",
      question: "Из каких стандартных циклов состоит производство работ?",
      answer: DEFAULT_ANSWER,
      listTitle: "",
      listType: "ul",
      listItems: [...DEFAULT_LIST_ITEMS],
      showOnHome: true,
    },
  ];
}

function normalizeListType(value) {
  if (value === "ol" || value === "ul") return value;
  return "";
}

function normalizeItem(item = {}) {
  const question = String(item.question || "").trim();
  const answer = String(item.answer || "").trim();
  if (!question || !answer) return null;

  const listItems = Array.isArray(item.listItems)
    ? item.listItems.map((entry) => String(entry || "").trim()).filter(Boolean)
    : String(item.listText || "")
      .split(/\r?\n/)
      .map((entry) => entry.trim())
      .filter(Boolean);

  return {
    id: String(item.id || createId()),
    question,
    answer,
    listTitle: String(item.listTitle || "").trim(),
    listType: normalizeListType(item.listType),
    listItems,
    showOnHome: item.showOnHome !== false,
  };
}

function normalizeData(raw) {
  if (!raw || typeof raw !== "object" || !Array.isArray(raw.items)) {
    return { items: getDefaultItems() };
  }

  return {
    items: raw.items.map((item) => normalizeItem(item)).filter(Boolean),
  };
}

function getFaqData() {
  const cached = window.NMApi?.cache?.faq;
  if (cached && Array.isArray(cached.items)) return normalizeData(cached);
  return { items: getDefaultItems() };
}

function saveFaqData(data) {
  const normalized = normalizeData(data);
  if (window.NMApi) {
    window.NMApi.cache.faq = normalized;
    window.NMApi.save("faq", normalized).catch((error) => {
      window.alert(error.message || "Не удалось сохранить FAQ"); // eslint-disable-line no-alert
    });
  }
  return normalized;
}

function getFaqItems() {
  return getFaqData().items;
}

function getHomeFaqItems() {
  return getFaqItems().filter((item) => item.showOnHome);
}

function upsertFaqItem(item) {
  const next = normalizeItem(item);
  if (!next) return getFaqData();
  const items = getFaqItems();
  const index = items.findIndex((entry) => entry.id === next.id);
  if (index >= 0) items[index] = next;
  else items.push(next);
  return saveFaqData({ items });
}

function deleteFaqItem(id) {
  return saveFaqData({
    items: getFaqItems().filter((item) => item.id !== id),
  });
}

function renderAnswerHtml(item) {
  const paragraphs = item.answer
    .split(/\n\s*\n/)
    .map((chunk) => chunk.trim())
    .filter(Boolean)
    .map((chunk) => `<p>${escapeHtml(chunk).replace(/\n/g, "<br>")}</p>`)
    .join("");

  const listType = item.listType && item.listItems.length ? item.listType : "";
  if (!listType) return paragraphs;

  const title = item.listTitle ? `<b>${escapeHtml(item.listTitle)}</b>` : "";
  const items = item.listItems.map((entry) => `<li>${escapeHtml(entry)}</li>`).join("");
  return `${paragraphs}${title}<${listType}>${items}</${listType}>`;
}

function renderFaqItem(item) {
  return `
    <div class="faq-section__accordion-item accordion__item">
      <button class="faq-section__accordion-trigger accordion__trigger d2" type="button">
        <span>${escapeHtml(item.question)}</span>
        <svg width="32" height="32" viewBox="0 0 32 32">
          <use xlink:href="#icon-plus"></use>
        </svg>
      </button>
      <div class="faq-section__accordion-content accordion__content user-content">
        ${renderAnswerHtml(item)}
      </div>
    </div>
  `;
}

function hydratePublicFaq() {
  const wrappers = document.querySelectorAll("[data-faq-list]");
  if (!wrappers.length) return;

  const allItems = getFaqItems();
  const homeItems = getHomeFaqItems();

  wrappers.forEach((wrapper) => {
    const node = wrapper;
    const section = node.closest(".faq-section");
    const onFaqPage = Boolean(document.querySelector(".faq-page"));
    const items = onFaqPage ? allItems : homeItems;
    if (section) {
      const sectionNode = section;
      sectionNode.hidden = !items.length;
    }
    node.innerHTML = items.map((item) => renderFaqItem(item)).join("");
  });
}

window.NMFaqContent = {
  STORAGE_KEY,
  createId,
  escapeHtml,
  getDefaultItems,
  normalizeItem,
  normalizeData,
  getFaqData,
  saveFaqData,
  getFaqItems,
  getHomeFaqItems,
  upsertFaqItem,
  deleteFaqItem,
  hydratePublicFaq,
};

window.NMApi?.ready?.then(hydratePublicFaq);
